import { render, staticRenderFns } from "./provideCommunity.vue?vue&type=template&id=4239267d&scoped=true&"
import script from "./provideCommunity.vue?vue&type=script&lang=js&"
export * from "./provideCommunity.vue?vue&type=script&lang=js&"
import style0 from "./provideCommunity.vue?vue&type=style&index=0&id=4239267d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239267d",
  null
  
)

export default component.exports